import { createContext } from "react"

const ExamContext = createContext();

export default ExamContext;